import { Pipe, PipeTransform, Predicate } from '@angular/core';

@Pipe({
    name: 'filterFor',
    standalone: false
})
export class FilterForPipe implements PipeTransform {

  transform(value: any[], filterFor: Predicate<any>): any {
    return value.find(filterFor)
  }

}
